import Modal, { WarningModal, ErrorModal } from "./Modal";
Modal.WarningModal = WarningModal;
Modal.ErrorModal = ErrorModal;
export default Modal;